import { GetThermometersQuery, ThermometerFragmentFragment } from 'data/__generated__';
import { GET_THERMOMETERS_QUERY } from 'data/queries/thermometer';
import { apolloClient } from '../../../App';

export const thermometersUpdatedOrCreatedHandler = (thermometersUpdatedOrCreated: ThermometerFragmentFragment[]) => {
    let currentThermometers = [] as GetThermometersQuery['getThermometers'];

    const result = apolloClient.readQuery<GetThermometersQuery>({ query: GET_THERMOMETERS_QUERY });
    if (!result) {
        return;
    }
    currentThermometers = result.getThermometers;

    const updatedOrCreatedThermometerIds = thermometersUpdatedOrCreated.map(({ _id }) => _id);
    const nonUpdatedOrCreatedThermometers = currentThermometers.filter(
        ({ _id }) => !updatedOrCreatedThermometerIds.includes(_id),
    );
    const newThermometers = [...thermometersUpdatedOrCreated, ...nonUpdatedOrCreatedThermometers];

    apolloClient.writeQuery<GetThermometersQuery>({
        query: GET_THERMOMETERS_QUERY,
        data: { getThermometers: newThermometers },
    });
};
